export const GRETA_AI_CHAT_PROJECTS_ALL_ICON_SIZE = 14

export const QA_NAME_GRETA_AI_CHAT_PROJECTS_TOGGLE = 'gretaAIChatProjectsToggle'

export const QA_NAME_GRETA_AI_CHAT_PROJECTS_ALL = 'gretaAIChatProjectsAll'
